module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/release-note/release-note.component.css
// module id = ./src/app/release-note/release-note.component.css
// module chunks = main